
export class MasterTaskTool {
  constructor(
    public hash?: string,
    public position?: number,
    public tool?: string,
    public toolName?: string,
    public toolHolder?: string,
    public toolHolderName?: string,
    public length?: number,
    public lastUpdate?: number,
    public status?: number,
    public masterTaskHash?: string,
    public created?: boolean,
    public sentToMeasure?: boolean,
    public measurementOK?: boolean,
    public measurementKO?: boolean,
    public markedToSend?: boolean
  ) { }

  clone() {
    return new MasterTaskTool(
      this.hash,
      this.position,
      this.tool,
      this.toolName,
      this.toolHolder,
      this.toolHolderName,
      this.length,
      this.lastUpdate,
      this.status,
      this.masterTaskHash,
      this.created,
      this.sentToMeasure,
      this.measurementOK,
      this.measurementKO,
      this.markedToSend
    );
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/master-task-tool.ts